import ScreenSizeObserver from '../helpers/ScreenSizeObserver';
import Deeplinker from '../helpers/Deeplinker';
import imageUrls from '../helpers/ImageUrlHelper';
import _ from 'lodash';

var proTournaments = [46];
var proSeasons = [11488, 10392, 9524];

var proSeasonsInfo = [
    {
        name: '2017/2018',
        id: 11488,
    },
    {
        name: '2016/2017',
        id: 10392,
    },
    {
        name: '2015/2016',
        id: 9524,
    },
];

var PromiseProps = function(obj) {
    var awaitables = [];
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var a = obj[key];
        awaitables.push(a);
    }

    return Promise.all(awaitables).then(function(results) {
        var byName = {};
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            byName[key] = results[i];
        }
        return byName;
    });
};

var promiseProps = PromiseProps;

var standardError = (code, message, data = {}) => {
    console.warn('Loader standard error', {
        ...data,
        error: true,
        message,
        code,
    });
    return promiseProps({
        __status: {
            ...data,
            error: true,
            message,
            code,
        },
    });
};

var i18Register = function(val, def) {
    if (_.isEmpty(val)) val = { en: {}, no: {}, da: {} };
    _.keys(val).forEach(lang => {
        val[lang] = _.merge({}, {}, def && def[lang], val[lang]);
    });

    return val;
};

// import tournamentsTranslations from '../../helpers/i18.tournaments';

var getLangFromContext = function() {
    if (!_.get(this, 'context.info')) console.warn('I18 - context missing', this.constructor.name);
    var lang = _.get(this, 'context.info.lang') || 'en';
    return lang;
};

var getTranslation = function(key, lang = 'en') {
    const i18Dict = i18Register(this.dict || {});

    let translation = _.get(i18Dict, `${lang}['${key}']`, '');

    //if no translation found for specified language, get english version
    if (!translation) translation = _.get(i18Dict, `en.['${key}']`, '');

    //if no english version found, return untranslated lang-key value
    if (!translation) translation = `$${lang}.${key}`;
    if (translation === ' ') return '';
    if (translation === '<empty>') return '';
    return translation;
};

var i18 = function(key, ...vals) {
    if (!key) return '';
    if (!this.context || !this.context.info) return console.warn('I18 - context missing', this.constructor.name);
    const dict = _.merge({}, this.i18CommonDict, this.i18dict);

    if (_.isEmpty(dict)) return console.warn('I18 - empty dictionary', this.constructor.name);

    var lang = this.context.info.lang || 'en';

    var label = '';
    if (dict[lang] && dict[lang][key]) {
        label = dict[lang][key];
    } else {
        if (typeof window !== 'undefined') {
            window.rlzI18 = window.rlzI18 || {};
            var val = key;
            window.rlzI18[key] = val;
        }
        // label = `$${lang}.${key}`;

        if (dict['en'] && dict['en'][key]) {
            console.warn(`I18 - missing $${lang}.${key} in`, this.constructor.name);
            label = dict['en'][key];
        } else {
            console.warn(`I18 - missing $${lang}.${key} in`, this.constructor.name);
            label = `$${lang}.${key}`;
        }
    }
    vals = vals || [];
    vals.forEach(function(val, i) {
        if (!val && val !== 0) return;
        if (typeof val === 'object') {
            Object.keys(val).forEach(function(valKey) {
                var v = val[valKey];
                label = label.replace(`{${valKey}}`, !_.isUndefined(val) && !_.isNull(val) ? v : '');
            });
        } else {
            label = label.replace(`{${i}}`, !_.isUndefined(val) && !_.isNull(val) ? val : '');
        }
    });

    if (label === ' ') return '';
    if (label === '<empty>') return '';
    return label;
    // return template (vals);
};

var playerShortName = function(name) {
    if (!name) return;
    var chunks = name.split(' ');
    if (chunks.length === 1) return name;
    var shortName = '';
    for (var i = 0; i < chunks.length - 1; i++) {
        var chunk = chunks[i];
        shortName += chunk[0] + '. ';
    }
    shortName += chunks[chunks.length - 1];
    return shortName;
};

const channelsImages = {
    'TV3 Sport': 'http://cdn.tjekscores.dk/tv/tv3sport.png',
    'TV3 Sport 1': 'http://cdn.tjekscores.dk/tv/tv3sport.png',
    'TV3 Sport 2': 'http://cdn.tjekscores.dk/tv/tv3sport.png',
    'TV3 Max': 'http://cdn.tjekscores.dk/tv/tv3max.png',
    'TV3+': 'http://cdn.tjekscores.dk/tv/tv3plus.png',
    'Canal 9': 'http://cdn.tjekscores.dk/tv/canal9.png',
    'EuroSport DK': 'http://spdk.tjekscores.dk/images/spdk/channels/TV_eurosport.png',
    'EuroSport 2': 'http://spdk.tjekscores.dk/images/spdk/channels/TV_eurosport.png',
    'Viasat Extra': 'http://cdn.tjekscores.dk/tv/viasat_extra.png',
};

var tvChannelToImg = function(name) {
    if (channelsImages[name]) return channelsImages[name] + '?a=1';
};

var isProStatsDataAvailable = (tournamentId, seasonId) => {
    const tournamentOk = proTournaments.indexOf(tournamentId) !== -1;
    if (!seasonId) return tournamentOk;
    return tournamentOk && proSeasons.indexOf(seasonId) !== -1;
};

var hasCDNPlayerLogos = (seasonId, client = 'core') => {
    if (client === 'tv2no') return [11522].indexOf(seasonId) !== -1;
    return [12725, 11488, 10392, 9524, 9731, 9730, 'current'].indexOf(seasonId) !== -1;
};

var hasCDNClubLogos = tournamentId => {
    return [46, 47, 54, 55, 57, 59, 67, 87, 42].indexOf(tournamentId) !== -1;
};

var formatValue = (val, key) => {
    if (!val) return '';
    switch (key) {
        case 'distanceData.topSpeed':
        case 'maxStats.distanceData.topSpeed':
            return val.toFixed(2);

        case 'distanceData.distance':
        case 'eventsStats.distanceData.distance':
        case 'averageStats.distanceData.distance':
            return val
                .toFixed(0)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        default:
            return val.toFixed(0);
    }
};

var getStatUnit = (key, short = true) => {
    switch (key) {
        case 'distanceData.topSpeed':
        case 'maxStats.distanceData.topSpeed':
            return 'km/h';
        case 'distanceData.distance':
        case 'averageStats.distanceData.distance':
            return short ? 'meters.short' : 'short';
        default:
            return null;
    }
};

var stylesObjectToString = stylesObject => {
    return Object.entries(stylesObject).reduce(
        (styleString, entry) => styleString + _.kebabCase(entry[0]) + ':' + entry[1] + ';',
        '',
    );
};

var getFirstLastName = (name = '') => {
    if (!name) return {};
    var nameChunks = name.split(' ');
    const lastName = _.last(nameChunks);
    const firstName = _.take(nameChunks, nameChunks.length - 1).join(' ');
    const firstNameChunks = firstName.split(' ');
    const shortFirstName = firstNameChunks.map(n => n.charAt(0).toUpperCase() + '.').join(' ');
    return {
        lastName,
        firstName,
        shortFirstName: shortFirstName.length > 1 ? shortFirstName : '',
    };
};

var prepareWidgetPropsObj = props => {
    var converted = {};
    Object.keys(props || {}).forEach(k => {
        const v = props[k];

        if (v === '' || v === null || v === 'undefined' || _.isUndefined(v)) return;
        if (_.isObject(v)) {
            converted[k] = JSON.stringify(v);
        } else {
            converted[k] = v;
        }
    });

    return converted;
};

var obj2InjectorParams = props => {
    var converted = {};

    Object.keys(props || {}).forEach(key => {
        const wkey = 'data-' + _.kebabCase(key);
        let value = props[key];
        try {
            // value = JSON.parse(value);
        } catch (e) {
            value = props[key];
        }
        converted[wkey] = value;
    });

    return converted;
};

var injectorParams2Obj = props => {
    var converted = {};
    Object.keys(props || {}).forEach(key => {
        let wkey = _.camelCase(key.replace('data-', ''));
        let value = props[key];

        try {
            value = JSON.parse(value);
        } catch (e) {
            value = props[key];
        }
        wkey = wkey.replace('h2H', 'h2h');
        converted[wkey] = value;
    });
    return converted;
};

var dataAttributesToObject = attributes => {
    return _.reduce(
        _.keys(attributes),
        function(result, attribute) {
            var name = attribute.split('data-')[1] || attribute;
            if (name.indexOf('-') !== -1) {
                name = name
                    .split('-')
                    .map(function(part, i) {
                        if (i === 0) return part;
                        return part.substr(0, 1).toUpperCase() + part.substr(1);
                    })
                    .join('');
            }
            var value;
            try {
                value = JSON.parse(attributes[attribute]);
            } catch (e) {
                value = attributes[attribute];
            }

            //Checks if value either null or undefined (as undefined == null)
            if (value == null) {
                return result;
            }
            // dirty hot fix
            name = name.replace('h2H', 'h2h');
            result[name] = value;
            return result;
        },
        {},
    );
};

var sportToId = sport => {
    if (sport === 'football' || sport === 'soccer') return 1;
    if (sport === 'handball') return 20;
    if (sport === 'basket' || sport === 'basketball') return 23;
    if (sport === 'tennis') return 2;
    if (sport === 'icehockey' || sport === 'hockey') return 5;
    if (sport === 'f1' || sport === 'F1') return 99;
    return 1;
};

var RCore = {
    proTournaments,
    proSeasons,
    proSeasonsInfo,
    obj2InjectorParams,
    injectorParams2Obj,
    standardError,
    ScreenSizeObserver,
    Deeplinker,
    PromiseProps,
    promiseProps: PromiseProps,
    i18,
    stylesObjectToString,
    playerShortName,
    isProStatsDataAvailable,
    hasCDNPlayerLogos,
    imageUrls,
    formatValue,
    i18Register,
    getFirstLastName,
    dataAttributesToObject,
    sportToId,
    hasCDNClubLogos,
    getLangFromContext,
    getTranslation,
    getStatUnit,
    prepareWidgetPropsObj,
    channelsImages,
    tvChannelToImg,
    nbsp: '\u00a0',
};

export default RCore;
export { RCore };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/RCore.js
 **/